import {Cookies} from '@stripe-internal/stripe-cookies';
import createCookieEventListener from 'src/internal/cookie/createCookieEventListener';

import type {IReports} from '@sail/observability';
import type {SimpleEventEmitter} from '@sail/utils';
import type {DataConfig} from 'src/internal/config/types';
import type {CookieEvent} from 'src/internal/cookie/createCookieEventListener';

type CookieObj = {
  stripeCookie: Cookies;
  eventListener: SimpleEventEmitter<[CookieEvent]>;
};

const emptyConfig = {};
const configMap = new WeakMap<
  NonNullable<DataConfig['browserStorage']>,
  CookieObj
>();

export default function initCookie(
  config: DataConfig['browserStorage'],
  reports: IReports,
): CookieObj {
  const potentialCookieObj = configMap.get(config ?? emptyConfig);

  if (potentialCookieObj) {
    return potentialCookieObj;
  }

  const stripeCookie = new Cookies({
    domainOverrides: config?.cookieDomainOverrides,
    enforcementMode: config?.enforcementMode,
  });

  const eventListener = createCookieEventListener(stripeCookie, reports);

  const cookieObj = {
    stripeCookie,
    eventListener,
  };

  configMap.set(config ?? emptyConfig, cookieObj);

  return cookieObj;
}
